<script setup>
import { nextTick, onMounted, ref } from 'vue';
import QuotesAPI from 'dashboard/api/talkviaQuotes';
import ContactsAPI from 'dashboard/api/contacts';
import { useAlert } from 'dashboard/composables';
import Button from 'dashboard/components-next/button/Button.vue';
import QuickQuoteDialog from 'dashboard/routes/dashboard/conversation/QuickQuoteDialog.vue';

const props = defineProps({
  quoteId: { type: [Number, String], required: true },
});
const dialog = ref();
const contact = ref({});
const busy = ref(false);
// Situação atual do orçamento: decide se o aceite ainda pode ser registrado aqui.
const status = ref('');
const loadStatus = async () => {
  try {
    const { data } = await QuotesAPI.show(props.quoteId);
    status.value = data.contract_id ? 'converted' : data.status;
  } catch {
    status.value = '';
  }
};
onMounted(loadStatus);
const approve = async () => {
  if (busy.value) return;
  busy.value = true;
  try {
    const { data } = await QuotesAPI.approve(props.quoteId);
    status.value = data.status;
    useAlert(
      data.calendar_event_id
        ? 'Aceite registrado e orçamento incluído na agenda.'
        : 'Aceite do orçamento registrado.',
      'success'
    );
  } catch (error) {
    useAlert(
      error?.response?.data?.error ||
        'Não foi possível registrar o aceite do orçamento.',
      'error'
    );
  } finally {
    busy.value = false;
  }
};
const edit = async () => {
  if (busy.value) return;
  busy.value = true;
  try {
    const { data: quote } = await QuotesAPI.show(props.quoteId);
    if (quote.status === 'expired' || quote.contract_id) {
      useAlert(
        'Orçamento expirado ou convertido. Consulte a página de contratos.'
      );
      return;
    }
    const { data } = await ContactsAPI.show(quote.contact_id);
    contact.value = data.payload || data;
    await nextTick();
    dialog.value?.open(quote);
  } catch {
    useAlert(
      'Orçamento indisponível. Ele pode ter sido excluído após a validade.'
    );
  } finally {
    busy.value = false;
  }
};
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template -->
  <div class="mt-1 flex flex-wrap items-center gap-2">
    <Button
      size="sm"
      variant="faded"
      color="slate"
      icon="i-hugeicons-pencil-edit-01"
      label="Editar orçamento"
      :disabled="busy"
      @click.stop="edit"
    />
    <Button
      v-if="status === 'sent'"
      size="sm"
      variant="faded"
      color="teal"
      icon="i-hugeicons-checkmark-circle-02"
      label="Registrar aceite"
      :disabled="busy"
      @click.stop="approve"
    />
    <span
      v-else-if="status === 'approved'"
      class="inline-flex items-center gap-1 rounded-lg bg-n-teal-3 px-2.5 py-1 text-xs font-medium text-n-teal-11"
    >
      <span class="i-hugeicons-checkmark-circle-02 size-4" aria-hidden="true" />
      Aceite registrado
    </span>
  </div>
  <QuickQuoteDialog
    ref="dialog"
    :contact="contact"
    @saved="loadStatus"
    @sent="loadStatus"
  />
</template>
